export const formatDateUTC = (dateString) => {
    return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // remove AM/PM also set 24 hours format
    }).format(new Date(dateString));
};